import React, { useState } from "react";
import useMediaQuery from "hooks/useMediaQuery";
import styles from "./index.module.css";
import ToggleSwitch from "components/common/ToggleSwitch";
import ScrollToTopButton from "components/common/ScrollToTopButton";

const BASE = process.env.PUBLIC_URL + "/svg";
const guideImages = {
    pc: {
        user: [1, 2, 3, 4, 5, 6].map((n) => `${BASE}/guides/${n}.svg`),
        admin: ["A1", "A2", "A3"].map((n) => `${BASE}/guides/${n}.svg`),
    },
    mobile: {
        user: [1, 2, 3, 4, 5, 6].map((n) => `${BASE}/guidesMobile/${n}.svg`),
        admin: ["A1", "A2", "A3"].map((n) => `${BASE}/guidesMobile/${n}.svg`),
    },
};

export default function Guides() {
    const [selectedSection, setSelectedSection] = useState("user");
    const [selectedIndex, setSelectedIndex] = useState(0);
    const isMobile = useMediaQuery("(max-width: 1023px)");

    // 📌 환경별 이미지 선택
    const sections = isMobile ? guideImages.mobile : guideImages.pc;

    const currentImages = sections[selectedSection];
    const currentImage = currentImages[selectedIndex] || null;

    // 📌 스와이프 감지용
    let touchStartX = 0;
    let touchEndX = 0;

    const handleTouchStart = (e) => {
        touchStartX = e.changedTouches[0].screenX;
    };

    const handleTouchEnd = (e) => {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
    };

    const handleSwipe = () => {
        const threshold = 50; // 최소 스와이프 거리
        if (touchStartX - touchEndX > threshold) {
            // 👉 왼쪽으로 스와이프 → 다음 이미지
            setSelectedIndex((prev) =>
                prev < currentImages.length - 1 ? prev + 1 : prev
            );
        }
        if (touchEndX - touchStartX > threshold) {
            // 👈 오른쪽으로 스와이프 → 이전 이미지
            setSelectedIndex((prev) => (prev > 0 ? prev - 1 : prev));
        }
    };

    return (
        <div className={styles.container}>
            {isMobile ? (
                <>
                    <ToggleSwitch
                        options={["사용자", "관리자"]}
                        onChange={(value, idx) => {
                            setSelectedSection(idx === 0 ? "user" : "admin");
                            setSelectedIndex(0);
                        }}
                    />
                    <div style={{ height: "5px" }} />
                    <ToggleSwitch
                        options={currentImages.map((_, idx) => `0${idx + 1}`)}
                        value={selectedIndex}
                        onChange={(value, idx) => setSelectedIndex(idx)}
                    />
                </>
            ) : (
                <div className={styles.toggles}>
                    <ToggleSwitch
                        options={["사용자", "관리자"]}
                        onChange={(value, idx) => {
                            setSelectedSection(idx === 0 ? "user" : "admin");
                            setSelectedIndex(0);
                        }}
                    />
                    <ToggleSwitch
                        options={currentImages.map((_, idx) => `Step 0${idx + 1}`)}
                        value={selectedIndex}
                        onChange={(value, idx) => setSelectedIndex(idx)}
                    />
                </div>
            )}

            {/* 📌 이미지에 스와이프 이벤트 연결 */}
            {currentImage && (
                <img
                    src={currentImage}
                    className={styles.imgWidths}
                    alt={`guide-${selectedSection}-${selectedIndex}`}
                    onTouchStart={handleTouchStart}
                    onTouchEnd={handleTouchEnd}
                />
            )}

            <ScrollToTopButton />
        </div>
    );
}
